import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

type PaymentIntentSummary = {
  total: number;
  pending: number;
  collected: number;
};

export function useAffiliatePaymentIntentsSummary(
  affiliateFirmId: string | null
) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: PaymentIntentSummary;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    affiliateFirmId
      ? `affiliate-firms/${affiliateFirmId}/payment-intents/summary`
      : null,
    SWRFetcher({ method: 'GET' })
  );

  return { data, error, mutate };
}
